// Zentrales Lead-Conversion-Tracking (Google Ads AW-16933113405)
// trackLead('formular' | 'anruf' | 'whatsapp', gewerkSlug, { transactionId })
//
// ======================================================================
// Google-Ads-Conversion-Labels (echte Labels, eingetragen am 27.10.2026)
// send_to = 'AW-16933113405/<LABEL>'
// ======================================================================
export const GOOGLE_ADS_ID = 'AW-16933113405';
export const FORMULAR_LABEL = 'UV7eCPHOoqsdEL2cq4o_'; // Formular-Lead (Wert 100)
export const ANRUF_LABEL = 'AJJbCPTOoqsdEL2cq4o_';    // Anruf-Klick (Wert 80)
export const WHATSAPP_LABEL = 'f8hACPfOoqsdEL2cq4o_'; // WhatsApp-Klick (Wert 30)

const LEAD_TYPES = {
  formular: { get label() { return FORMULAR_LABEL; }, value: 100 },
  anruf: { get label() { return ANRUF_LABEL; }, value: 80 },
  whatsapp: { get label() { return WHATSAPP_LABEL; }, value: 30 },
};

const DEBUG = true;
const DEDUP_MS = 1500;
const __lastFired = {};

const hasMarketingConsent = () => {
  try {
    const c = localStorage.getItem('bekaj-cookie-consent');
    return c ? JSON.parse(c).marketing === true : false;
  } catch {
    return false;
  }
};

/**
 * Feuert ein Lead-Event: dataLayer-Event `lead_<typ>` immer (lokal),
 * Google-Ads-Conversion nur bei Marketing-Consent UND echtem Label (≠ 'XXXX').
 */
export const trackLead = (typ, gewerk = null, { transactionId = null } = {}) => {
  const cfg = LEAD_TYPES[typ];
  if (!cfg) {
    if (DEBUG) console.warn('[trackLead] unbekannter Typ:', typ);
    return false;
  }
  const now = Date.now();
  if (now - (__lastFired[typ] || 0) < DEDUP_MS) {
    if (DEBUG) console.log('[trackLead] deduped:', typ);
    return false;
  }
  __lastFired[typ] = now;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: `lead_${typ}`,
    gewerk: gewerk || null,
    transaction_id: transactionId || null,
  });

  if (cfg.label === 'XXXX') {
    if (DEBUG) console.log(`[trackLead] ${typ}: Label noch 'XXXX' → keine Ads-Conversion (nur dataLayer)`);
    return false;
  }
  if (!hasMarketingConsent()) {
    if (DEBUG) console.log(`[trackLead] ${typ}: kein Marketing-Consent → keine Ads-Conversion`);
    return false;
  }
  if (typeof window.gtag !== 'function') {
    if (DEBUG) console.log('[trackLead] gtag nicht verfügbar');
    return false;
  }
  const payload = {
    send_to: `${GOOGLE_ADS_ID}/${cfg.label}`,
    value: cfg.value,
    currency: 'EUR',
  };
  if (transactionId) payload.transaction_id = transactionId;
  try {
    window.gtag('event', 'conversion', payload);
    if (DEBUG) console.log(`[trackLead] Ads-Conversion gefeuert: ${typ}`, payload);
    return true;
  } catch (e) {
    if (DEBUG) console.warn('[trackLead] Fehler:', e);
    return false;
  }
};

/** Telefonnummer → E.164 (+49…) für Enhanced Conversions. */
export const toE164 = (raw) => {
  if (!raw) return null;
  const hasPlus = String(raw).trim().startsWith('+');
  const digits = String(raw).replace(/\D+/g, '');
  if (!digits) return null;
  if (hasPlus) return `+${digits}`;
  if (digits.startsWith('00')) return `+${digits.slice(2)}`;
  if (digits.startsWith('0')) return `+49${digits.slice(1)}`;
  return `+${digits}`;
};

/** Enhanced Conversions: user_data nur bei Marketing-Consent setzen. */
export const setEnhancedConversionData = ({ phone, email } = {}) => {
  if (!hasMarketingConsent()) {
    if (DEBUG) console.log('[EnhancedConv] kein Marketing-Consent → user_data nicht gesetzt');
    return false;
  }
  if (typeof window.gtag !== 'function') return false;
  const user_data = {};
  if (phone) user_data.phone_number = phone;
  if (email) user_data.email = email;
  if (Object.keys(user_data).length === 0) return false;
  window.gtag('set', 'user_data', user_data);
  if (DEBUG) console.log('[EnhancedConv] user_data gesetzt (Felder):', Object.keys(user_data));
  return true;
};
